import { render, staticRenderFns } from "./SearchRestaurant.vue?vue&type=template&id=68bf7388"
import script from "./SearchRestaurant.vue?vue&type=script&lang=js"
export * from "./SearchRestaurant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports